import XEUtils from 'xe-utils'
import 'vxe-table-quantdata/lib/style.css'
import Vue from 'vue'
import httpManager from '../../util/common'
import companySearch from '../../home/components/CompanySearch'

Vue.use('vxe-utils');
Vue.use('vxe-table');

let vm = {
  delimiters: ['{', '}'],
  props: {},
  data: () => {
    return {
      entityCount: 0,
      loading: false,
      follow_entity_customer: false,
      follow_entity_supplier: false,
      page: {
        total: 0,
        currentPage: 1,
        pageSize: 10,
        align: 'center',
        pagerCount: 3,
        layouts: ['PrevPage', 'Number', 'NextPage'],
        perfect: true
      },
      data: [],
      exportConfig: {},
      supplier_oaid: null,
      customer_oaid: null,
      disclosure_oaid: null,
      announcement_id: null,
      start_date: null,
      end_date: null,
      endOpen: false,
      transaction_type: null,
      typeoptions: [
        {label: '全部', value: null},
        {label: '合作', value: '合作'},
        {label: '工程/项目', value: '工程/项目'},
        {label: '其他', value: '其他'},
        {label: '国有资源', value: '国有资源'},
        {label: '采购/销售', value: '采购/销售'},
        {label: '租赁', value: '租赁'},
        {label: '专利/商标', value: '专利/商标'}
      ],
      tableColumn: [
        {type: 'seq', width: 50},
        {title: 'i18n.supplychain.announcement_date', field: "announcement_date",
          formatter: ({ cellValue }) => {
              return XEUtils.toDateString(cellValue, 'yyyy-MM-dd')
            }
        },
        {title: 'i18n.supplychain.announcement_id', field: "announcement_id"},
        {title: 'i18n.supplychain.publish_host', field: "entity_name", type:"html", className: "click-cell-style",
          formatter: ({row}) => {
            return '<a target="_blank" href="/entity/'+row.entity_name+'/home">'+row.entity_name+'</a></br><a target="_blank" href="/entity/'+row.short_name_ticker+'/home">'+row.short_name_ticker+'</a>'
          }
        },
        {title: 'i18n.supplychain.supplier', field: "suppliers", type:"html", className: "click-cell-style",
          formatter: ({ cellValue })=>{
            let result = []
            let as = cellValue
            for(let a in as){
              if(as[a].oa_id){
                result.push('<a target="_blank" href="/entity/'+as[a].oa_id+'/home">'+as[a].name+'</a>')
              }else{
                result.push(as[a].name)
              }
              if(as[a].short_name_ticker){
                let tickers = as[a].short_name_ticker.split(",")
                for(let t in tickers){
                  result.push('<a target="_blank" href="/entity/'+tickers[t]+'/home">'+tickers[t]+'</a>')
                }
              }
            }
            return result.join('</br>')
        }
        },
        {title: 'i18n.supplychain.customer', field: "customers", type:"html", className: "click-cell-style",
          formatter: ({ cellValue })=>{
            let result = []
            let as = cellValue
            for(let a in as){
              if(as[a].oa_id){
                result.push('<a target="_blank" href="/entity/'+as[a].oa_id+'/home">'+as[a].name+'</a>')
              }else{
                result.push(as[a].name)
              }
              if(as[a].short_name_ticker){
                let tickers = as[a].short_name_ticker.split(",")
                for(let t in tickers){
                  result.push('<a target="_blank" href="/entity/'+tickers[t]+'/home">'+tickers[t]+'</a>')
                }
              }
            }
            return result.join('</br>')
        }
        },
        {title: 'i18n.supplychain.transaction_type', field: "transaction_type"},
        {title: 'i18n.supplychain.transaction_deliverable', field: "transaction_deliverable"},
        {
          title: 'i18n.supplychain.money', field: "transaction_amount", formatter: ({cellValue}) => {
            return cellValue ? `${XEUtils.commafy(XEUtils.toNumber(cellValue), {digits: 2})}` : ''
          }
        },
        {title: 'i18n.supplychain.plan_period', field: "transaction_period",
          formatter: ({row}) => {
            if(row.transaction_period && row.transaction_period_unit){
              return row.transaction_period +""+ (row.transaction_period_unit=='Y'?"年":row.transaction_period_unit=='M'?"月":row.transaction_period_unit?"日":null)
            }
          }
        },
        {title: 'i18n.supplychain.related_party_transaction', field: "related_party_transaction"},
        {title: 'i18n.supplychain.stage_type', field: "transaction_stage"},
        {title: 'i18n.supplychain.parent_announcement_id', field: "parent_announcement_id"},
        {title: 'i18n.supplychain.info_sources', field: "announcement_url", slots: {default: 'num_default'}},
      ]
    }
  },
  methods: {
    disabledStartDate(start_date) {
      const end_date = this.end_date;
      if (!start_date || !end_date) {
        return false;
      }
      return start_date.valueOf() > end_date.valueOf();
    },
    disabledEndDate(end_date) {
      const start_date = this.start_date;
      if (!end_date || !start_date) {
        return false;
      }
      return start_date.valueOf() >= end_date.valueOf();
    },
    handleStartOpenChange(open) {
      if (!open) {
        this.endOpen = true;
      }
    },
    handleEndOpenChange(open) {
      this.endOpen = open;
    },
    openDataExport() {
      let s = "TOP供应链"
      this.$refs.xTable_data.openExport({
        filename: s + XEUtils.toDateString(new Date().getTime(), 'yyyyMMddHHmmss'),
        original: false,
        types: ['csv']
      })
    },
    pageChange({currentPage, pageSize}) {
      this.page.currentPage = currentPage
      this.page.pageSize = pageSize
      this.getData()
    },
    getData() {
      let self = this
      self.loading = true
      let params = new Map()
      params.set("pagenum", self.page.currentPage)
      params.set("pagesize", self.page.pageSize)
      params.set("follow_entity_supplier", self.follow_entity_supplier)
      params.set("follow_entity_customer", self.follow_entity_customer)
      if (self.supplier_oaid)
        params.set("supplier_oaid", self.supplier_oaid)
      if (self.disclosure_oaid)
        params.set("disclosure_oaid", self.disclosure_oaid)
      if (self.customer_oaid)
        params.set("customer_oaid", self.customer_oaid)
      if (self.announcement_id)
        params.set("announcement_id", self.announcement_id)
      if (self.start_date)
        params.set('start_date', self.start_date)
      if (self.end_date)
        params.set('end_date', self.end_date)
      if (self.transaction_type)
        params.set('transaction_type', self.transaction_type)
      httpManager("sc_announcement_table", params, null, null, null)
        .then(response => {
          self.data = response.data.data
          console.log(self.data);
          let page = response.data.page
          this.page.total = page.total
          self.loading = false
        })
        .catch(error => {
          console.log(error)
          self.loading = false
        })
    },
  },
  mounted() {
    this.getData()
  },
  watch: {
    supplier_oaid: function () {
      this.page.currentPage = 1
      this.getData()
    },
    customer_oaid: function () {
      this.page.currentPage = 1
      this.getData()
    },
    follow_entity_supplier: function () {
      this.page.currentPage = 1
      this.getData()
    },
    follow_entity_customer: function () {
      this.page.currentPage = 1
      this.getData()
    },
    disclosure_oaid: function () {
      this.page.currentPage = 1
      this.getData()
    },
    announcement_id: function () {
      this.page.currentPage = 1
      this.getData()
    },
    start_date: function () {
      this.page.currentPage = 1
      this.getData()
    },
    end_date: function () {
      this.page.currentPage = 1
      this.getData()
    },
    transaction_type: function () {
      this.page.currentPage = 1
      this.getData()
    },
  },
  created() {
  },
}
Vue.component("sc-announcement", vm)
export default vm



// WEBPACK FOOTER //
// ./src/supplychain/js/supply_chain_announcement.js